import { useEffect, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./App.css";
import Footer from "./components/Footer";
import { prefetchRewardAd } from "./components/AdUnit";

// Lazy load components
const Home = lazy(() => import("./pages/Home"));
const GameDetails = lazy(() => import("./pages/GameDetails"));
const Contact = lazy(() => import("./pages/Contact"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const TermsOfUse = lazy(() => import("./pages/TermsOfUse"));


function App() {


  useEffect(() => {
    const alreadyWatched = sessionStorage.getItem("reward_shown");
    if (!alreadyWatched) {
      prefetchRewardAd({
        onReward: () => sessionStorage.setItem("reward_shown", "true"),
        onClose: () => { },
      });
    }
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <div className="min-h-screen bg-[#132440] text-slate-100 flex flex-col font-inter selection:bg-indigo-500/30">
          <main className="flex-1 overflow-x-hidden">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/game/:slug" element={<GameDetails />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsOfUse />} />
            </Routes>

          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
